$(function(){
    $(window).on("scroll", function(){
        if($(window).scrollTop() > 0) {
            $("body").addClass("scroll");
        } else {
            $("body").removeClass("scroll");
        }
    });

    $('nav a[href*="#"]:not([href="#"])').click(function() {
        var that = $(this);
        if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
                var offset = 0;
                if(that.data('scroll-offset') !== undefined) {
                    offset = that.data('scroll-offset');
                }

                $('html, body').animate({
                    scrollTop: target.offset().top - offset
                }, 1000);

                return false;
            }
        }
    });
});